import { connect } from 'react-redux'

import { registerClub } from '../../components/Forms/FormRegisterClub/reducer'
import { checkLogin } from '../Login/reducer'
import { getAccountOrders } from './components/TicketsAndReserv/reducer'
import { logout } from './reducer'

const mapStateToProps = (state) => {
    const { pages, components, services } = state

    const loading =
        pages?.userProfile?.loading ??
        pages.cinestarClub?.loading ??
        components?.forms?.registerClub?.loading ??
        components?.forms?.contactInfo?.loading ??
        components?.forms?.changePassword?.loading ??
        components?.forms?.lostCard?.loading ??
        false

    const error =
        pages?.userProfile?.error ??
        pages.cinestarClub?.error ??
        components?.forms?.registerClub?.error ??
        components?.forms?.contactInfo?.error ??
        components?.forms?.changePassword?.error ??
        components?.forms?.lostCard?.error ??
        null

    const success = {
        registerClub: components?.forms?.registerClub?.success,
        lostCard: components?.forms?.lostCard?.success,
        contactInfo: components?.forms?.contactInfo?.success,
        changePassword: components?.forms?.changePassword?.success,
    }

    return {
        isAuth: services?.auth?.isAuthorized ?? false,

        firstname: services?.user?.firstname ?? '',
        lastname: services?.user?.lastname ?? '',
        user: services?.user,

        points: services?.user?.loyalty_program?.points ?? 0,
        cardValidity: services?.user?.loyalty_program?.card?.validity ?? null,
        isCardValid: services?.user?.loyalty_program?.card?.is_valid,
        isCardExpiring: services?.user?.loyalty_program?.card?.is_expiring,

        loading,
        error,
        success,
    }
}

const mapDispatchToProps = { logout, registerClub, checkLogin, getAccountOrders }

const hocUserProfile = (InnerComponent) => connect(mapStateToProps, mapDispatchToProps)(InnerComponent)

export default hocUserProfile
